export default "__VITE_ASSET__BRHuUx9Q__"